export const FIGHT_DATA_ACTIONS = {
    MONSTER_TAKE_DAMAGE_BY_ID: 'fightData monster take damage by id',
    REMOVE_MONSTER_BY_INDEX: 'fightData remove monster by index',
    SET_END_FIGHT_DATA: 'fightData set endFightData',
    IS_DATA_PLAYER_ATTACK: 'fightData player attack',
    IS_DATA_PLAYER_SPECIAL_ATTACK: 'fightData player special attack',
    IS_DATA_PLAYER_ESCAPE: 'fightData player escape',
    IS_DATA_PLAYER_INVENTORY: 'fightData player inventory',
}